module.exports = __webpack_public_path__ + "static/media/big-gift-icon.ca1a1eb3.svg";